import { replace } from 'lodash'
export const replaceAll = (str:string, find:string, replace:string) => {
    return str.replace(new RegExp(find, "g"), replace);
}

export const replaceHtmlSpecialCharacters = (text:string) => {
    let replacedText = text
    const specialCharacters = {
        '&#038;': '&',
        '&amp;': '&',
        '&#62;': '>',
        '&gt;': '>',
        '&#60;': '<',
        '&lt;': '<',
        '&#39;': "'",
        '&apos;': "'",
        '&quot;': '"',
        '&#34;': '"',
        '&#8217;': '’',
        '&rsquo;': '’',
        '&#8211;': '-',
    }
    Object.entries(specialCharacters).forEach(([specialCharacter, replacedCharacter]) => {
        replacedText = replace(replacedText, new RegExp(specialCharacter, 'g'), replacedCharacter)
    })
    return replacedText
}

export const removeSpacesFromPhoneNumber = (str = "") => {
    return str.replace(/\s/g, "")
}
export const addSpacesFromPhoneNumber = (str = "") => {
    if (str.substring(0, 3) === "+48") {
        return `${str.substring(0, 3)} ${str.substring(3, 6)} ${str.substring(
            6,
            9,
        )} ${str.substring(9)}`
    }

    return `${str.substring(0, 3)} ${str.substring(3, 6)} ${str.substring(6)}`
}
